import { RouteConfig } from 'vue-router';
import { Permissions } from '@/types';
const Subscriptions = () =>
  import(/* webpackChunkName: "subscription-routes" */ '@/components/Subscriptions/Subscriptions.vue');

const routes: RouteConfig[] = [
  {
    path: 'subscriptions',
    name: 'subscriptions',
    components: {
      default: Subscriptions
    },
    meta: {
      pageTitle: 'Subscription',
      permission: Permissions.QUERY_TRANSLATIONS
    }
  }
];

export default routes;
